import { format } from 'date-fns';

import apiRequestActionCreator from '../apiRequestActionCreator';
import {
    addItem,
    fetchCollection,
    fetchItem,
    processItemError,
    updateItem,
} from '../collectionActions';

const paramsFunction = ({ params }) => ({
    ...params,
    dueDate: params.dueDate && format(new Date(params.dueDate), 'yyyy-MM-dd'),
});

export const fetchMaintenanceIssues = fetchCollection({
    apiCollectionName: 'maintenance-issue',
    collectionActionName: 'MAINTENANCE_ISSUES',
    paramsFunction: ({ params }) => ({ ...params, planned: true }),
});

export const fetchReactiveMaintenanceIssues = fetchCollection({
    apiCollectionName: 'maintenance-issue',
    collectionActionName: 'REACTIVE_MAINTENANCE_ISSUES',
    paramsFunction: ({ params }) => ({ ...params, planned: false }),
});

export const fetchMaintenanceIssue = fetchItem({
    apiCollectionName: 'maintenance-issue',
    itemActionName: 'MAINTENANCE_ISSUE',
});

export const updateMaintenanceIssue = updateItem({
    apiCollectionName: 'maintenance-issue',
    itemActionName: 'MAINTENANCE_ISSUE',
    paramsFunction,
});

export function uploadMaintenanceIssueAttachment({ formData, id }) {
    return apiRequestActionCreator({
        actionName: 'MAINTENANCE_ISSUE_ATTACHMENTS',
        params: {
            data: formData,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            method: 'post',
            url: `maintenance-issue/${id}/attachments`,
        },
    });
}

export const addMaintenanceIssue = addItem({
    apiCollectionName: 'maintenance-issue',
    itemActionName: 'MAINTENANCE_ISSUE',
    params: {
        timeout: 30 * 60000,
        transformRequest: [({ attachments, ...rest }) => JSON.stringify(rest)],
    },
    paramsFunction,
    processSuccessResponse: async ({ data }, { data: { attachments } }, dispatch) => {
        if (attachments && attachments.length) {
            for (let index = 0; index < attachments.length; index += 1) {
                const formData = new FormData();
                formData.append('file', attachments[index]);

                await dispatch(uploadMaintenanceIssueAttachment({ formData, id: data.id }));
            }
        }
        // dispatch(showIssueCreationSuccessMessage()); // FIXME
        return data;
    },
});

export function createComponentValue({ issueId, itemId, body }) {
    return apiRequestActionCreator({
        actionName: 'CREATE_COMPONENT_VALUE',
        params: {
            data: body,
            method: 'post',
            url: `maintenance-issue/${issueId}/item/${itemId}/component-value`,
        },
        processError: error => processItemError({ error }),
    });
}
